import { TRIGGER_LABELS, TRIGGERS, type Trigger } from '@tahi/core';
import { useEffect, useState } from 'react';
import { Button, Chip, Sheet } from '../../../ui';
import { copy } from '../copy';
import { LABEL } from '../styles';
import { DelayTimer } from './DelayTimer';

interface Props {
  open: boolean;
  onOpenChange(open: boolean): void;
  /** Delay timer end (epoch ms) or null; `now` ticks every second while open. */
  until: number | null;
  now: number;
  onStartDelay(): void;
  onResisted(trigger: Trigger | null, delayUsed: boolean): void;
  onSmoked(trigger: Trigger | null, delayUsed: boolean): void;
}

export function CravingSheet({
  open,
  onOpenChange,
  until,
  now,
  onStartDelay,
  onResisted,
  onSmoked,
}: Props) {
  const [trigger, setTrigger] = useState<Trigger | null>(null);
  useEffect(() => {
    if (open) setTrigger(null);
  }, [open]);
  const delayUsed = until !== null;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
      title={copy.cravingTitle}
      description={copy.cravingHint}
    >
      <div className="flex flex-col gap-4">
        <div>
          <p className={LABEL}>{copy.whatTriggered}</p>
          <div role="group" aria-label={copy.whatTriggered} className="mt-2 flex flex-wrap gap-2">
            {TRIGGERS.map((t) => (
              <Chip
                key={t}
                selected={trigger === t}
                aria-pressed={trigger === t}
                onClick={() => setTrigger(trigger === t ? null : t)}
              >
                {TRIGGER_LABELS[t]}
              </Chip>
            ))}
          </div>
        </div>
        <DelayTimer until={until} now={now} onStart={onStartDelay} />
        <div className="flex flex-col gap-2">
          <Button variant="primary" block onClick={() => onResisted(trigger, delayUsed)}>
            {copy.gotThrough}
          </Button>
          <Button variant="ghost" block onClick={() => onSmoked(trigger, delayUsed)}>
            {copy.smokedOne}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
